<template>
  <autocomplete-single
      ref="autocomplete"
      :name="name"
      :search-text.sync="searchText"
      :items="items"
      :select.sync="localSelect"
      :loading="loadState.isLoading"
      :flat="flat"
      :icon="icon"
      :placeholder="placeholder"
      backgroundColor="white"
      :exclude="exclude !==undefined ? exclude : false"
      @open="includeAction"
  >
    <template v-slot:itemInfo="{item}">
      <v-row no-gutters class="caption">
        <template v-if="showId !== undefined">
          <v-col cols="auto">id: {{ item.id }}</v-col>
          <v-col cols="auto"><dot/></v-col>
        </template>
        <v-col cols="auto">{{item.userProfile.gender==='male'?'Мужчина':'Женщина'}}</v-col>
        <v-col v-if="!$tools.isEmpty(item.userProfile.birth)" cols="auto"><dot/></v-col>
        <v-col v-if="!$tools.isEmpty(item.userProfile.birth)" cols="auto">{{$tools.dateYears(item.userProfile.birth,'YYYY-MM-DD')}}</v-col>
        <v-col cols="auto"><dot/></v-col>
        <v-col cols="auto">{{item.type==='admin' ? 'Администратор' : item.type==='spec' ? 'Специалист' : 'Клиент'}}</v-col>
        <v-col v-if="item._recom!==undefined" cols="12" class="primary--text">Общий номер телефона</v-col>
      </v-row>
    </template>
  </autocomplete-single>
</template>

<script>
import State from "@/plugins/state";
import AutocompleteSingle from "@/componentsV2/base/AutocompleteSingle.vue";
import {
  Entity_User,
  Entity_UserProfile,
} from "../../../EntityStoreCacheService";
import Dot from "@/componentsV2/base/Dot.vue";
export default {
  components: {AutocompleteSingle, Dot},
  props:[
    'name',
    'select',
    'exclude',
    'include',
    'showId',
    'flat',
    'icon',
    'placeholder',
    '_type',
  ],
  data:()=>({
    loadState: new State(),
    searchText: null,
    items:[],
    localSelect: null
  }),
  watch: {
    select() {
      this.externalSelectData();
    },
    localSelect() {
      this.$emit('update:select', this.localSelect)
    },
    searchText(){
      this.$tools.debounce(()=>{
        this.load();
      });
    }
  },
  mounted() {
    this.externalSelectData();
  },
  methods: {
    externalSelectData() {
      this.localSelect = this.select;
      if(this.localSelect!==undefined && this.localSelect!==null) {
        this.localSelect.name = this.$tools.userFullName(this.localSelect)
        this.items = [this.localSelect];
      }
    },
    load() {
      let rb = new Entity_User()
      .selects(Entity_User.id)
      .selects(Entity_User.lastName)
      .selects(Entity_User.firstName)
      .selects(Entity_User.secondName)
      .selects(Entity_User.type)
      .selects([Entity_UserProfile.entity, Entity_UserProfile.birth].join('.'))
      .selects([Entity_UserProfile.entity, Entity_UserProfile.gender].join('.'))


      if (!this.$tools.isEmpty(this.searchText)) {
        let v = this.searchText.trim();
        if (/^\d+$/.test(v)&& v.length>0) { // id
          rb.filterAnd([Entity_User.entity, Entity_User.id].join('.') + ' =?', v)
        } else {
          let arr = v.split(' ');
          if (arr.length === 1 && arr[0][0] === '(') {//Для старой фамилии в скобках
            rb.filterAnd([Entity_User.entity, Entity_User.lastName].join('.') + ' LIKE ?', '%' + arr[0] + '%')
          } else if (arr.length === 1) {
            rb.filterAnd([Entity_User.entity, Entity_User.lastName].join('.') + ' LIKE ?', arr[0] + '%')
          } else if (arr.length === 2) {
            rb.filterAnd([Entity_User.entity, Entity_User.lastName].join('.') + ' LIKE ?', arr[0] + '%')
            rb.filterAnd([Entity_User.entity, Entity_User.firstName].join('.') + ' LIKE ?', arr[1] + '%')
          } else if (arr.length === 3) {
            rb.filterAnd([Entity_User.entity, Entity_User.lastName].join('.') + ' LIKE ?', arr[0] + '%')
            rb.filterAnd([Entity_User.entity, Entity_User.firstName].join('.') + ' LIKE ?', arr[1] + '%')
            rb.filterAnd([Entity_User.entity, Entity_User.secondName].join('.') + ' LIKE ?', arr[2] + '%')
          }
        }
      }
      
      if (this._type!==undefined)
        rb.filterAnd([Entity_User.entity, Entity_User.type].join('.') + ' =?', this._type)

      rb.addStateCallback((v) => {
        this.loadState.setRequestBuilderState(v)
      })
      .page(null)
      .request((v)=>{       
        let newItems = v.items.map(item => ({
          ...item,
          name: this.$tools.userFullName(item)
        }));

        newItems = this.items.concat(newItems);
        newItems = this.$tools.sortByKey(newItems)
        this.items = this.$tools.uniqueByKey(newItems)

      }, (e)=>{
        console.error(e.response.data.message);
      })  
    },
    includeAction(){    
      if (this.include !== undefined) {
        let arr = [];
        this.include.forEach(v=>{
          if(this.items.filter(v1=>v1.id===v.id).length===0){
            v._recom = true;
            arr.push(v);
          }
        });
        if(arr.length>0) {
          this.items = [...arr, ...this.items]
        }
      }  
    },
    open(){
      this.$refs.autocomplete.open()
    }
  }
}
</script>